import { z } from 'zod';
import { PlayerColor } from './PlayerState.ts';
export const singleDieSchema = z.number().int().min(1).max(6);
export const twoDiceSumSchema = z.number().int().min(2).max(12);
export const uniquePlayerColorsArraySchema = z.array(z.enum(PlayerColor)).refine((playerColors)=>new Set(playerColors).size == playerColors.length, {
    message: 'Player colors must not contain duplicate entries'
});
